

import React from 'react'
const Menu = (props) => {
		return(
			<nav className="nav" style = { props.divStyle }>
				<div className="menu-container">
					<ul className="menu-nav" onClick = { props._handleClick } >
						<li className="nav-item"><a href="/">Home</a></li>
						<li className="nav-item"><a href="">Blog</a></li>
						<li className="nav-item"><a href="/project">Project</a></li>
					</ul>
				</div>
			</nav>

		)
}
export default Menu


// WEBPACK FOOTER //
// ./src/components/nav.js